import React, { Context } from 'react';

const { createContext, useContext } = React;

type GuardContextType = 'ldap' | 'api';

let GuardContext: Context<GuardContextType> =
  createContext<GuardContextType>('api');

export const useGuard = (): GuardContextType => {
  return useContext<GuardContextType>(GuardContext);
};

export const GuardProvider = ({
  guard,
  children,
}: {
  guard: GuardContextType;
  children: any;
}) => <GuardContext.Provider value={guard} children={children} />;
